import MarcasCarousel from './marcascarousel';

export default MarcasCarousel;